import requester from '@/utils/request'

export const uploadService = {
  // 获取STS Token - 阿里云
  getSTSToken: (data: any) => requester.post('/file/aliyun/queryStsInfo', data),
  // 上传成功后的上报 - 阿里云
  reportBigFileUrl: (data: any) => requester.post('/file/aliyun/reportBigFileUrl', data),
  // 异常上报接口 - 阿里云
  reportUploadErrorMsg: (data: any) => requester.post('/file/aliyun/reportUploadErrorMsg', data),
  // 取消上传 - 阿里云
  cancelUploadBigFile: (data: any) => requester.post('/file/aliyun/cancelUploadBigFile', data),
}
